import { render } from "./IDCard.vue?vue&type=template&id=4cd04ca5"
import script from "./IDCard.vue?vue&type=script&lang=js"
export * from "./IDCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__